import * as config from "./categories/config.js";
import * as account from "./categories/account.js";
import * as notice from "./categories/notice.js";
import * as promo from "./categories/promo.js";

const api = {
  ...account,
  ...config,
  ...notice,
  ...promo
};

window.api = api;
